<template>
  <div>
    <span v-if="data.column.field === 'minimumBidValue' || data.column.field === 'maximumBidValue'">
      <div class="d-flex justify-content-between align-items-center">
        <b-form-input
          :value="data.row[data.column.field] || ''"
          size="sm"
          step=".01"
          type="number"
          @input="updateBidValue($event, data.row, data.column.field)"
        />
        <div
          v-if="data.column.field === 'maximumBidValue'"
          class="d-flex align-items-center ml-2"
        >
          <b-button
            variant="link"
            class="p-0"
            @click="saveBidStrategySubtypeMapping(data.row)"
          >
            <GjIcon
              name="Save"
              class="text-primary"
            />
          </b-button>
          <b-button
            v-b-modal.modal-delete-bid-strategy
            variant="link"
            class="p-0"
            @click="deleteBidStrategySubtypeMapping(data.row)"
          >
            <GjIcon
              name="Delete"
              class="text-danger"
            />
          </b-button>
        </div>
      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'
import notification from '@/mixins/toastification'
import BidStrategiesService from '@/api/admin/bidStrategies.service'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const deleteBidStrategySubtypeMapping = model => store.commit('SET_BID_STRATEGY_SUBTYPE_TO_DELETE', model)
    const saveBidStrategySubtypeMapping = async model => {
      try {
        const response = await BidStrategiesService.updateBid(model)
        if (response.saved) {
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      }
    }
    const updateBidValue = (value, row, field) => {
      if (value === '' || value === null || value === undefined) {
        row[field] = null
      } else {
        const numValue = parseFloat(value)
        row[field] = Number.isNaN(numValue) ? null : numValue
      }
    }
    return { deleteBidStrategySubtypeMapping, saveBidStrategySubtypeMapping, updateBidValue }
  },
}
</script>
